import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RegistrationWorkflow } from './registration-workflow.service';
import { BusinessClock } from '../../../core/time/business-clock.service';

/** Runs before STEP2 can release temporary reservations, including direct URLs after reload. */
export const registrationRecoveryGuard: CanActivateFn = async () => {
  const workflow = inject(RegistrationWorkflow);
  const router = inject(Router);
  if (!await inject(BusinessClock).synchronize()) return false;
  const destination = workflow.resume();
  if ((workflow.unknown || workflow.busy) && destination) {
    return router.createUrlTree(['/step4', destination.type, destination.studioId]);
  }
  if (workflow.message) return router.createUrlTree(['/step4', 'new_membership', 0]);
  return true;
};
